import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import './Login.css';

import errorMessages from './errorMessages';

import { APIs } from '../../constants/endPointsURLs';

import InputField from '../common/InputField/InputField';
import Button from '../common/Button/Button';
import ResetPasswordWizard from './ResetPasswordWizard';

import { version } from '../../../package.json';

class Login extends React.Component {
  state = {
    companyName: '',
    username: '',
    password: '',
    showPassword: false,
    isFormValid: false,
    isErrorMessageDisplayed: false,
    currentErrorMessage: 'placeholder',
    isLogginIn: false,
    isResettingPassword: false,
  };

  inputCompanyRef = React.createRef();
  inputPasswordRef = React.createRef();

  componentDidMount() {
    this._isMounted = true;
    this.inputCompanyRef.current.focus();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleFormChange = (e) => {
    if (this._isMounted === false) {
      return;
    }

    if (e.target.id === 'company-name') {
      this.setState({ companyName: e.target.value }, () => {
        this.validateForm();
      });
    } else if (e.target.id === 'username') {
      this.setState({ username: e.target.value }, () => {
        this.validateForm();
      });
    } else if (e.target.id === 'password') {
      this.setState({ password: e.target.value }, () => {
        this.validateForm();
      });
    }
  };

  validateForm = () => {
    const { companyName, username, password } = this.state;
    if (companyName.length >= 2 && username.length >= 2 && password.length >= 6) {
      this.setState({ isFormValid: true });
    } else {
      this.setState({ isFormValid: false });
    }
  };

  handleShowPassword = () => {
    this.setState(
      {
        ...this.state,
        showPassword: !this.state.showPassword,
      },
      () => {
        this.inputPasswordRef.current.focus();
      },
    );
  };

  handleLogin = () => {
    this.setState({
      isErrorMessageDisplayed: false,
      isLogginIn: true,
    });
    const { companyName, username, password } = this.state;

    axios({
      method: 'post',
      url: APIs.login,
      data: {
        companyName,
        username,
        password,
      },
      withCredentials: true,
      validateStatus: function (status) {
        return status >= 200;
      },
    })
      .then((response) => {
        this.setState({ isLogginIn: false });
        if (response.status === 200) {
          this.props.setLogin(response.data);
        } else if (response.status === 403) {
          this.setState({
            isErrorMessageDisplayed: true,
            currentErrorMessage: errorMessages.credentials,
          });
        } else if (response.status >= 500) {
          this.setState({
            isErrorMessageDisplayed: true,
            currentErrorMessage: errorMessages.serverErr,
          });
        }
      })
      .catch((err) => {
        console.error(err);

        this.setState({
          isErrorMessageDisplayed: true,
          currentErrorMessage: errorMessages.serverNoResponse,
          isLogginIn: false,
        });
      });
  };

  handleResetPassword = (e) => {
    e.preventDefault();
    this.setState({ isResettingPassword: true });
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter' && this.state.isFormValid) {
      this.handleLogin();
    }
  };

  render() {
    const {
      companyName,
      username,
      password,
      showPassword,
      isFormValid,
      isErrorMessageDisplayed,
      currentErrorMessage,
      isLogginIn,
    } = this.state;




    return (
      <div className="login-container">
        <div className="login-sidebar">
          <div className="sidebar-content">
            <div className="sidebar-logo">
              <img src="./images/logo.svg" alt="Omnistream" />
            </div>
            <div className="sidebar-message">
              <h1>Broadcast with <span className="text-accent">Confidence</span>.</h1>
              <p>Reliable live video transmission solutions for the modern broadcaster.</p>
            </div>
            <div className="sidebar-graphic">
              <div className="glow-blue"></div>
              <div className="glow-orange"></div>
            </div>
          </div>
        </div>

        <div className="login-main">
          <div className="login-form-wrapper">
            <div className="mobile-logo">
              <img src="./images/logo.svg" alt="Omnistream" />
            </div>

            {this.state.isResettingPassword ? (
              <ResetPasswordWizard
                onCancel={() => this.setState({ isResettingPassword: false })}
                onSuccess={(data) => this.props.setLogin(data)}
              />
            ) : (
              <div className="login-form">
                <div className="form-header">
                  <h2>Welcome Back</h2>
                  <p>Please enter your credentials to continue</p>
                </div>

                <div className="form-fields">
                  <div className="form-group">
                    <InputField
                      uniqueId="company-name"
                      labelName="Email / Company Name"
                      type="text"
                      value={companyName}
                      changeHandler={this.handleFormChange}
                      onKeyDown={this.handleKeyDown}
                      reference={this.inputCompanyRef}
                    />
                  </div>
                  <div className="form-group">
                    <InputField
                      uniqueId="username"
                      labelName="Username"
                      type="text"
                      value={username}
                      changeHandler={this.handleFormChange}
                      onKeyDown={this.handleKeyDown}
                    />
                  </div>
                  <div className="form-group input-container password-group">
                    <InputField
                      uniqueId="password"
                      labelName="Password"
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      changeHandler={this.handleFormChange}
                      onKeyDown={this.handleKeyDown}
                      reference={this.inputPasswordRef}
                      customElement={
                        <span
                          className="material-icons"
                          onClick={this.handleShowPassword}
                        >
                          {showPassword ? 'visibility_off' : 'visibility'}
                        </span>
                      }
                    />
                    <div className="reset-password-container">
                      <span className="reset-password-link" onClick={this.handleResetPassword}>
                        Reset Password?
                      </span>
                    </div>
                  </div>

                  <div className="login-button-container">
                    <Button
                      uniqueId="login-button"
                      showSpinner={isLogginIn}
                      text={isLogginIn ? 'Logging In..' : 'Login'}
                      isDisabled={!isFormValid}
                      clickHandler={this.handleLogin}
                    />
                  </div>

                  <div
                    className={`error-card ${isErrorMessageDisplayed ? 'visible' : 'invisible'}`}>
                    <div className="error-content">
                      <i className="material-icons">error_outline</i>
                      <div className="error-text">
                        <span className="error-title">Login Failed</span>
                        <p>{currentErrorMessage}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="login-footer">
              <div className="version-txt">
                Version: {version}
              </div>
              <div className="site-center-text">
                Site: {process.env.REACT_APP_HOSTNAME.split('.')[0].toUpperCase()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  screenSize: PropTypes.string,
  setLogin: PropTypes.func.isRequired,
};

export default Login;
